import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Script from '../Script';
/**
 * Render a JavaScript snippet that loads Genesys Web Messenger.
 */

export default function GenesysWebChatSnippet(_ref) {
  var _ref$deploymentId = _ref.deploymentId,
      deploymentId = _ref$deploymentId === void 0 ? '' : _ref$deploymentId,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? 'use1' : _ref$environment,
      rest = _objectWithoutProperties(_ref, ["deploymentId", "environment"]);

  return /*#__PURE__*/React.createElement(Script, _extends({
    async: true,
    globalScriptKey: "genesys",
    skipServerRender: true,
    charset: "utf-8",
    dangerouslySetInnerHTML: {
      __html: "\n          (function (g, e, n, es, ys) {\n            g['_genesysJs'] = e;\n            g[e] = g[e] || function () {\n              (g[e].q = g[e].q || []).push(arguments)\n            };\n            g[e].t = 1 * new Date();\n            g[e].c = es;\n            ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);\n          })(window, 'Genesys', 'https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js', {\n            environment: '".concat(environment, "',\n            deploymentId: '").concat(deploymentId, "'\n          });\n        ")
    }
  }, rest));
}
GenesysWebChatSnippet.propTypes = {
  deploymentId: PropTypes.string,
  environment: PropTypes.string
};